export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '分期编码中奖配置';
